import React from 'react';

import { Skeleton } from '@mui/material';
import PropTypes from 'prop-types';

import { SKELETON_TYPES } from 'constants/skeleton';

const PaperSkeleton = ({ type }) => {
  return (
    <Skeleton
      animation="pulse"
      height={type === SKELETON_TYPES.PAPER_SMALL ? '265px' : '100%'}
      variant="rectangular"
      width="100%"
    />
  );
};

PaperSkeleton.propTypes = {
  type: PropTypes.string.isRequired,
};

export default PaperSkeleton;
